import ClickMap from './click-map.svg';
import Inspect from './inspect.svg';
import ScrollMaps from './scroll-maps.svg';
import ClickMapsClicked from './click-maps-clicked.svg';
import ClickMapsDeadClicked from './click-maps-dead-clicked.svg';
import ClickMapsErrorClicked from './click-maps-error-clicked.svg';
import ClickMapsRageClicked from './click-maps-rage-clicked.svg';

export default {
  'page-insights/click-map': ClickMap,
  'page-insights/click-maps-clicked': ClickMapsClicked,
  'page-insights/click-maps-dead-clicked': ClickMapsDeadClicked,
  'page-insights/click-maps-error-clicked': ClickMapsErrorClicked,
  'page-insights/click-maps-rage-clicked': ClickMapsRageClicked,
  'page-insights/inspect': Inspect,
  'page-insights/scroll-maps': ScrollMaps,
};
